module.exports = __webpack_public_path__ + "img/rascrut-12.b44d23ff.webp";